<template>
  <div>
    <el-form
      ref="form1"
      :model="form1"
      label-width="80px"
      size="mini"
      label-position="top"
    >
      <el-card shadow="never">
        <el-tag type="info" size="mini">关于我们</el-tag>

        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="标题" required>
                <el-input
                  v-model="form1.footer_aboutus_title"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item label="内容" required>
                <el-input
                  type="textarea"
                  v-model="form1.footer_aboutus_content"
                  :rows="4"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('form1')"
                  size="small"
                  >保存</el-button
                >
                <el-button @click="resetHomepage('11')" size="small"
                  >重置</el-button
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-form>

    <el-card style="margin-top: 20px" shadow="never">
      <el-tag type="info" size="mini">大赛链接</el-tag>

      <el-row style="margin-top: 20px">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <el-button type="primary" @click="addLinks" size="mini"
              >添加链接</el-button
            >

            <el-table
              class="addcourses"
              :data="tableData"
              border
              :header-cell-style="{ background: '#f5f7fa' }"
            >
              <el-table-column prop="title" label="名称"></el-table-column>
              <el-table-column prop="url" label="链接"></el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="primary"
                    @click="updateLinks(scope.row)"
                    >修改</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    @click="deleteLinks(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <el-form
              class="form"
              ref="form4"
              :model="form1"
              label-width="80px"
              size="mini"
              label-position="top"
            >
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark">
                    <el-form-item label="标题" required>
                      <el-input
                        v-model="form4.footer_match_title"
                        maxlength="30"
                        show-word-limit
                      ></el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="submitForm('form4')"
                        size="small"
                        >保存</el-button
                      >
                      <el-button @click="resetHomepage('12')" size="small"
                        >重置</el-button
                      >
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top: 20px" shadow="never">
      <el-tag type="info" size="mini">联系我们</el-tag>

      <el-form
        class="form"
        ref="form2"
        :model="form2"
        label-width="80px"
        size="mini"
        label-position="top"
      >
        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="标题" required>
                <el-input
                  v-model="form2.footer_contact_title"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item label="地址" required>
                <el-input
                  v-model="form2.footer_contact_address"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item label="电话" required>
                <el-input
                  v-model="form2.footer_contact_tel"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item label="微信号" required>
                <el-input
                  v-model="form2.footer_contact_wechat"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('form2')"
                  size="small"
                  >保存</el-button
                >
                <el-button @click="resetHomepage('13')" size="small"
                  >重置</el-button
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px" shadow="never">
      <el-form
        class="form"
        ref="form3"
        :model="form3"
        label-width="80px"
        size="mini"
        label-position="top"
      >
        <el-tag type="info" size="mini">扫码关注</el-tag>

        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="标题" required>
                <el-input
                  v-model="form3.footer_wx_title"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item label="图片" required>
                <el-upload
                  action=""
                  :http-request="uploadFile"
                  :on-remove="handleRemove"
                  :on-change="handleChangeFile"
                  :auto-upload="false"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="form3.fileList"
                  list-type="picture"
                  style="width: 400px"
                >
                  <el-button size="mini" type="primary" plain
                    >点击上传<i class="el-icon-upload el-icon--right"></i
                  ></el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过500kb
                  </div>
                </el-upload>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('form3')"
                  size="small"
                  >保存</el-button
                >
                <el-button @click="resetHomepage('14')" size="small"
                  >重置</el-button
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px" shadow="never">
      <el-tag type="info" size="mini">是否开启</el-tag>
      <div style="margin-top: 20px;">
        <el-switch
          v-model="footer_is_show"
          active-text="开启"
          inactive-text="关闭"
          @change="changefooter"
        >
        </el-switch>
      </div>
    </el-card>
    <el-dialog title="比赛链接" :visible.sync="dialogVisible" width="800px">
      <el-form
        class="form-style"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="200px"
        label-position="right"
      >
        <el-form-item label="标题" required>
          <el-input
            placeholder="请输入标题"
            v-model="form.title"
            style="width: 400px"
            maxlength="30"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label="链接" required>
          <el-input
            placeholder="请输入跳转链接"
            v-model="form.url"
            style="width: 400px"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit('form')"
          >保存</el-button
        >
        <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  uploadLinks,
  updateLinks,
  deleteLinks,
  updateHomepage,
  resetHomepage,
} from '@/api/homeset'
import uploadFile from '@/config/uploadFile'

export default {
  name: 'homeset-footer',
  props: {
    homepageFooterMatch: Array,
    homepage_id: Number,
    aboutusData: Array,
    contantData: Array,
    qrcodeData: Array,
    footer_match_title: String,
    footer_is_show: Boolean,
  },

  data() {
    return {
      tableData: [],
      imageId: '',
      dialogVisible: false,
      form: {
        title: '',
        url: '',
      },

      form1: {
        footer_aboutus_title: '',
        footer_aboutus_content: '',
      },
      form2: {
        footer_contact_title: '',
        footer_contact_address: '',
        footer_contact_tel: '',
        footer_contact_wechat: '',
      },

      form3: {
        footer_wx_title: '',
        fileList: [],
      },

      form4: {
        footer_match_title: '',
      },
      rules: [],
    }
  },

  watch: {
    homepageFooterMatch() {
      this.tableData = this.homepageFooterMatch
    },
    aboutusData() {
      console.log('this.aboutusData')
      console.log(this.aboutusData)

      this.form1.footer_aboutus_title = this.aboutusData[0]
      this.form1.footer_aboutus_content = this.aboutusData[1]
    },
    contantData() {
      this.form2.footer_contact_title = this.contantData[0]
      this.form2.footer_contact_address = this.contantData[1]
      this.form2.footer_contact_tel = this.contantData[2]
      this.form2.footer_contact_wechat = this.contantData[3]
    },
    qrcodeData() {
      this.form3.footer_wx_title = this.qrcodeData[0]
      this.form3.fileList = [
        {
          url: this.qrcodeData[1],
          name: this.qrcodeData[1].split('/')[
            this.qrcodeData[1].split('/').length - 1
          ],
        },
      ]
    },
    footer_match_title() {
      this.form4.footer_match_title = this.footer_match_title
    },
  },

  methods: {
    changefooter() {
      updateHomepage({
        id: this.homepage_id,
        footer_is_show: this.footer_is_show === false ? '0' : '1',
      }).then((res) => {
        if (res.is_update) {
          this.$message.success('保存成功！')
        }
      })
    },
    addLinks() {
      this.form.title = ''
      this.form.url = ''
      this.imageId = ''
      this.dialogVisible = true
    },

    updateLinks(row) {
      this.imageId = row.id
      this.form.title = row.title
      this.form.url = row.url
      this.dialogVisible = true
    },

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imageId) {
            updateLinks({
              id: this.imageId,
              title: this.form.title,
              url: this.form.url,
              homepage_id: this.homepage_id,
            }).then((res) => {
              if (res.is_update) {
                this.$message.success('修改成功!')
                this.dialogVisible = false
                this.tableData = this.tableData.map((item) =>
                  item.id === res.result.id ? res.result : item
                )
              }
            })
          } else {
            uploadLinks({
              title: this.form.title,
              url: this.form.url,
              homepage_id: this.homepage_id,
            }).then((res) => {
              if (res.is_create) {
                this.$message.success('添加成功!')
                this.dialogVisible = false
                this.tableData.push(res.result)
              }
            })
          }
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(formName)

          updateHomepage({
            id: this.homepage_id,
            footer_aboutus_title: this.form1.footer_aboutus_title,
            footer_aboutus_content: this.form1.footer_aboutus_content,
            footer_contact_title: this.form2.footer_contact_title,
            footer_contact_address: this.form2.footer_contact_address,
            footer_contact_tel: this.form2.footer_contact_tel,
            footer_contact_wechat: this.form2.footer_contact_wechat,

            footer_wx_title: this.form3.footer_wx_title,
            footer_wx_img_url: this.form3.fileList[0].url,
            footer_match_title: this.form4.footer_match_title,
          }).then((res) => {
            if (res.is_update) {
              this.$message.success('保存成功！')
            }
          })
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    uploadFile() {},

    async handleChangeFile(file, fileList) {
      if (file.size > 1024 * 500) {
        // 500kb
        this.form3.fileList.pop()
        return this.$message.warning('图片不符合规则，请重新上传！')
      } else {
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList)
        }
      }
    },

    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form3.fileList = res
          this.uploadFileTime = false
        }
      )
    },

    deleteLinks(row) {
      this.$confirm('确定删除本条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteLinks({
          id: row.id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success('删除成功！')

            for (var i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].id === row.id) {
                this.tableData.splice(i, 1)
              }
            }
          }
        })
      })
    },

    //重置校区信息
    resetHomepage(type) {
      this.$confirm('确定重置信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        resetHomepage({
          reset_type: type,
        }).then((res) => {
          console.log('重置信息')
          console.log(res)
          if (res.is_update) {
            this.$message.success('重置成功,请刷新本页面')
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.table-style {
  margin-top: 20px;
}

.addcourses {
  margin-top: 20px;
}

.form {
  margin-top: 20px;
  width: 1000px;
}

.aboutus {
  margin-top: 20px;
}
</style>
